<ng-container *ngIf="configs$ | async as config">
  <div class="tile-loyalty" *ngIf="config?.sharedLoyaltyState?.loyaltyConfig?.enabled_for_market">
    <ng-container *ngIf="config?.sharedLoyaltyState?.loyaltyConfig?.enabled_for_account; else requestStep">
      <ng-container *ngIf="config?.accountState?.agentNumber > 0; then pointsTile; else enrollmentTile"></ng-container>
    </ng-container>

    <ng-template #requestStep>
      <ng-container
        *ngIf="config?.customerConfig?.customerConfig?.is_decision_maker; then approveTile; else requestTile"
      >
      </ng-container>
    </ng-template>

    <!--Tiles-->
    <ng-template #requestTile>
      <app-loyalty-request-tile
        [requested]="config?.loyaltyTileConfig?.isRequested"
        (requestAccessTriger)="onRequest()"
      >
      </app-loyalty-request-tile>
    </ng-template>

    <ng-template #approveTile>
      <app-loyalty-approve-tile (approveTrigger)="onApprove()"></app-loyalty-approve-tile>
    </ng-template>

    <ng-template #enrollmentTile>
      <app-loyalty-enrollment-tile
        [isLoading]="config?.customerProfileState?.isLoading || (agentState$ | async)?.isLoading"
        (loginTrigger)="onLogin()"
        (createAccountTrigger)="onCreateAccount()"
        (initTrigger)="getCustomerProfile(config?.customerConfig?.customerConfig?.default_store_code)"
      >
      </app-loyalty-enrollment-tile>
    </ng-template>

    <ng-template #pointsTile>
      <app-loyalty-points-tile
        [pointsState]="pointsState$ | async"
        [agentNumber]="config?.accountState?.agentNumber"
        (loadPointsTrigger)="onLoadPoints()"
        (clickByOrderGiftsTrigger)="redirectToOrderGifts()"
      >
      </app-loyalty-points-tile>
    </ng-template>
  </div>
</ng-container>
